import styles from "./styles.module.scss";
import WesLadd from "../../assets/aboutUs/personCard1.png";

const CardBlock = () => {
  return (
    <section className={styles.leadership} aria-labelledby="leadership-title">
      <div className={styles.leadershipInner}>
        <header className={styles.leadershipHeading}>
          <p className={styles.eyebrow}>Leadership</p>
          <h2 id="leadership-title">
            Experience in the field. Clarity in the classroom.
          </h2>
        </header>

        <article className={styles.profileCard}>
          <figure className={styles.profileVisual}>
            <img
              src={WesLadd}
              alt="Wes Ladd seated at a table with a laptop"
              width="2400"
              height="1380"
              loading="lazy"
            />
            <span aria-hidden="true" />
          </figure>

          <div className={styles.profileContent}>
            <p className={styles.profileRole}>Founder and Lead Instructor</p>
            <h3>Wes Ladd</h3>
            <div className={styles.profileCopy}>
              <p>
                Wes has experience helping some of the largest and most heavily
                regulated organizations—including Fortune 500 Banking, Energy,
                and Healthcare clients.
              </p>
              <p>
                Wes has served in a variety of capacities, from Internal Auditor
                to Penetration Tester to Cloud Security Architect. Through this
                experience, Wes gained a diverse array of skills and a passion
                for teaching.
              </p>
            </div>

            <ul className={styles.experienceList} aria-label="Areas of experience">
              <li>Internal audit</li>
              <li>Penetration testing</li>
              <li>Cloud security</li>
            </ul>

            <a
              className={styles.academyLink}
              href="https://academy.traingrc.com/p/home"
            >
              Explore the Academy
              <span aria-hidden="true">→</span>
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};

export default CardBlock;
